import {
  GET_PROJECTS_LIST_LOADING,
  GET_PROJECTS_LIST_FULFILLED,
  GET_PROJECTS_LIST_REJECTED,
  GET_CONFIGS_LOADING,
  GET_CONFIGS_FULFILLED,
  GET_CONFIGS_REJECTED,
} from 'actions/projects-list/projects-list.actions';

const initialState = {
  list: [],
  listLoading: false,
  listError: null,
  configs: {},
  configsLoading: false,
  configsError: null,
};

const projectsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECTS_LIST_LOADING:
      return {
        ...state,
        listLoading: true,
      };
    case GET_PROJECTS_LIST_FULFILLED:
      return {
        ...state,
        listLoading: false,
        list: action.data.list,
        listError: null,
      };
    case GET_PROJECTS_LIST_REJECTED:
      return {
        ...state,
        ...initialState,
        listError: action.data.error.message,
      };

    case GET_CONFIGS_LOADING:
      return {
        ...state,
        configsLoading: true,
      };
    case GET_CONFIGS_FULFILLED:
      return {
        ...state,
        configsLoading: false,
        configs: action.data?.configs || {},
        configsError: null,
      };
    case GET_CONFIGS_REJECTED:
      return {
        ...state,
        ...initialState,
        configsError: action.data.error.message,
      };
    default:
      return state;
  }
};

export default projectsListReducer;
